/**
 * @desc Snowmaking layers to import into the store
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

import layers from "./layers";

export default {
  modules: {
    layers
  },
  state: {
    name: "signshop",
    deptTitle: "Sign Shop",
    icon: "directions",
    split: true,
    splitNames: [{ name: "On Mountain Signs" }, { name: "Signs By Division" }]
  }
};
